import React from 'react'
import Grid from '@material-ui/core/Grid'
import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import NativeSelect from '@material-ui/core/NativeSelect'
import MenuItem from '@material-ui/core/MenuItem'

// Wrapper canônico para alinhar selects com TextFields lado a lado: o
// TextField com label já vive dentro de um FormControl + InputLabel + Input
// + FormHelperText, e esse offset de 16px do label flutuante é o que faz a
// borda inferior bater. Selects nus (sem FormControl) ficam alguns pixels
// mais acima e quebram o alinhamento.
function FormSelect({
  visible,
  required,
  error,
  errorText,
  id,
  name,
  label,
  value,
  onChange,
  options,
  native = false,
  outerClassName,
  innerClassName,
  gridSm = 6
}) {
  if (!visible) return null

  // O Select dá warning se o value não casar com nenhum MenuItem. Quando
  // o estado inicial é uma sentinela ('-1', '', null), coage para '' para
  // o InputLabel flutuar naturalmente e o Select não logar.
  const matched = options.some((o) => String(o.value) === String(value))
  const safeValue = matched ? value : ''

  return (
    <Grid item xs={12} sm={gridSm} className={outerClassName}>
      <FormControl fullWidth required={required} error={Boolean(error)} className={innerClassName}>
        <InputLabel htmlFor={id}>{label}</InputLabel>
        {native ? (
          <NativeSelect
            name={name}
            value={safeValue}
            onChange={onChange}
            inputProps={{ id }}
          >
            <option value="" />
            {options.map((opt) => (
              <option value={opt.value} key={opt.value}>
                {opt.label}
              </option>
            ))}
          </NativeSelect>
        ) : (
          <Select
            name={name}
            value={safeValue}
            onChange={onChange}
            inputProps={{ id }}
          >
            {options.map((opt) => (
              <MenuItem value={opt.value} key={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </Select>
        )}
        <FormHelperText>{error ? errorText : ''}</FormHelperText>
      </FormControl>
    </Grid>
  )
}

export default FormSelect
